import React from "react";
import { pickLocale } from "../../lib/format";
import { adfAssets } from "./assets";

/**
 * A scrolling band of short phrases, separated by the falcon mark.
 *
 * The reference lists several phrases; an editor supplies one string, so it is
 * split on the separators an editor would naturally reach for. A single phrase
 * still works — it simply repeats, which is what the band did before.
 *
 * Seamlessness is structural, not luck. The track is TWO identical halves and
 * the animation translates it by exactly -50%, so the moment the first half
 * scrolls out the second is already in its place. Each half repeats enough to
 * be wider than any viewport, so the seam never shows on a wide desktop.
 */
const PER_HALF = 4;

function Half({ items }) {
  return (
    <div className="flex shrink-0 items-center">
      {Array.from({ length: PER_HALF }, (_, round) =>
        items.map((item, index) => (
          <span key={`${round}-${index}`} className="flex items-center">
            <span className="px-6 text-[10px] tracking-[0.2em] uppercase text-charcoal font-semibold">
              {item}
            </span>
            {/* The atelier's own mark between phrases, in place of the rotated
                square that stood in for it. The whole band is aria-hidden, so
                this is decoration and carries no alt text. */}
            <img
              src={adfAssets.logoMono}
              alt=""
              aria-hidden="true"
              className="h-3 w-auto shrink-0 opacity-45"
              draggable={false}
            />
          </span>
        )),
      )}
    </div>
  );
}

export default function Marquee({ text, locale = "az", enabled = true, testId }) {
  const phrase = (pickLocale(text, locale) || "").trim();
  if (!enabled || !phrase) return null;
  const items = phrase.split(/\s*[·•|]\s*/).filter(Boolean);

  return (
    <div
      className="bg-white border-b border-charcoal/5 overflow-hidden py-3 flex items-center whitespace-nowrap relative"
      aria-hidden="true"
      data-testid={testId}
    >
      <div className="adf-ref-marquee-track flex">
        <Half items={items} />
        <Half items={items} />
      </div>
    </div>
  );
}
